export default __webpack_public_path__ + "static/media/startups_hero.ce90810c.jpeg";